import { CancelOutlined } from "@mui/icons-material";
import { useTranslation } from "react-i18next";
import "./FooterNavigatorAutoSearch.scss";
import { devLog } from "utils/devLog";

/**
 *
 * @param {*} props
 * @returns
 */
export default function FooterNavigationAutoSearch(props) {
  const { t } = useTranslation();

  const onUserBack = (e) => {
    devLog("UI Cancel pressed");
    if (typeof props.onUserBack == "function") {
      props.onUserBack();
    }
  };

  const onNextClick = (e) => {
    devLog("UI Next pressed");
    if (typeof props.onNextClick == "function") {
      props.onNextClick();
    }
  };

  return (
    <>
      <div className="footerContainer" style={{ display: "flex" }}>
        <button className="ui-btn not-me-btn" onClick={onUserBack}>
          {t("description.NotMe")}
        </button>
        <div>
          <button type="submit" className="ui-btn" onClick={onNextClick}>
            {t("description.ConfirmServicesContinue")}
          </button>
        </div>
      </div>
    </>
  );
}
